import React, {useState} from "react";
import {useCalcContext} from "../../contexts/CalcContext";
import {useUserContext} from "../../contexts/UserContext";
import {LocationModal} from "../DealPage/LocationModal";
import {useModalsStore} from "../../stores/modalsStore";
import classnames from "classnames";
import {buildLocationString, parseGoogleAddressData} from "../../utils/utils";
import Autocomplete from "react-google-autocomplete";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";

const SelectLocationItem = (props) => {
    const {
        location,
        selectedLocation,
        handleLocationChange,
    } = props

    const isSelected = Boolean(location.id === selectedLocation.id)

    return (
        <div
            className={classnames('pinned-option', {
                selected: isSelected
            })}
            onClick={() => handleLocationChange(location)}
        >
            <span className="pinned-option-text">{`${location.county || ''}, ${location.state || ''} ${location.zipcode || ''}`.trim()}</span>
            <svg className="pin-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="5"/>
                <circle cx="12" cy="8" r="2.5" fill="rgba(0,0,0,0.25)"/>
                <line x1="12" y1="13" x2="12" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </div>
    )
}

const SelectLocationItemZipInput = (props) => {
    const {
        location,
        setLocation,
        handleLocationChange,
        selectedLocation,
    } = props

    const [inputValue, setInputValue] = useState(() => buildLocationString(location))

    return (
        <div className="search-row">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>""</svg>
            <Autocomplete
                placeholder="Search ZIP, city, or county..."
                className={classnames('CreateLocationInput_input', {
                    disabled: false
                })}
                onChange={(e) => setInputValue(e.target.value)}
                style={{
                    zIndex: "inherit",
                    width: "100%",
                    border: 'none',
                    outline: 'none'
                }}
                value={inputValue}
                inputAutocompleteValue={buildLocationString(location)}
                apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                onPlaceSelected={(place) => {
                    const parsed = parseGoogleAddressData(place.address_components)
                    setInputValue(buildLocationString(parsed))
                    setLocation(parsed)
                    handleLocationChange(parsed)
                }}
                options={{
                    types: ['postal_code'],
                    componentRestrictions: { country: 'us' },
                    fields: ['address_components', 'name']
                }}
            />
        </div>
    )
}

export const CalcPageSelectLocation = () => {
    const { profileState } = useUserContext()
    const { quoteSettings } = useDefaultQuoteSettingsContext()
    const [tab, setTab] = useState('Customer');
    const isCustomerTab = tab === 'Customer'
    const openModal = useModalsStore((state) => state.openModal)
    const [customerZipLocation, setCustomerZipLocation] = useState(null)
    const [dealerZipLocation, setDealerZipLocation] = useState(null)

    const {
        calcState,
        setCalcState,
        saveLocation,
    } = useCalcContext()

    const defaultLocation = quoteSettings.customer_location
    const selectedLocation = isCustomerTab ? calcState.location : calcState.dealer_location
    const pinnedLocations = profileState.pinned_locations
    const displayedLocations = [defaultLocation, ...pinnedLocations]
    const displayedLocationIds = displayedLocations.map(l => l.id)
    const hasZipLocation = isCustomerTab ? Boolean(customerZipLocation) : Boolean(dealerZipLocation)
    const shouldDisplaySelectedLocation = !displayedLocationIds.includes(selectedLocation.id) && !hasZipLocation

    return (
        <div className={'panel location-panel'}>
            <div className="panel-header">
                <div className="panel-title">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:16, height:16}}>
                        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                    </svg>
                    Location Selection
                </div>
            </div>
            <div className="panel-body">
                {
                    false &&
                    <React.Fragment>
                        {/* Tabs preserved from source but hidden */}
                    </React.Fragment>
                }
                {
                    isCustomerTab &&
                    <SelectLocationItemZipInput
                        selectedLocation={selectedLocation}
                        location={customerZipLocation}
                        setLocation={setCustomerZipLocation}
                        handleLocationChange={(location) => saveLocation(location, true, true)}
                    />
                }
                {
                    shouldDisplaySelectedLocation &&
                    <SelectLocationItem
                        location={selectedLocation}
                        selectedLocation={selectedLocation}
                        handleLocationChange={(location) => saveLocation(location, true, true)}
                    />
                }
                <div className={'Pinned-locations-container'}>
                    {
                        displayedLocations.map(
                            (location) => {
                                return (
                                    <SelectLocationItem
                                        key={location.id}
                                        location={location}
                                        selectedLocation={selectedLocation}
                                        handleLocationChange={(location) => saveLocation(location, true, true)}
                                    />
                                )
                            }
                        )
                    }
                </div>
                <div style={{display:'flex', justifyContent:'flex-start', alignItems:'center', height:'44px'}}>
                    <button
                        className={'btn-edit'}
                        onClick={() => {
                            openModal({
                                element: LocationModal,
                                id: "LocationModal",
                                props: {
                                    selectLocation: saveLocation,
                                }
                            })
                        }}
                    >
                        Edit
                    </button>
                </div>
            </div>
        </div>
    )
}
